import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';

const checkClaimStatus = {
    methods : {
        handleAjax : (el,policyNumber , dobLifeInsured ,dateOfEvent)=>{
            let comingDateObject =(dobLifeInsured)? new Date(dobLifeInsured):'';
            let formattedDateLA = (dobLifeInsured)? comingDateObject.getDate() + "-" + comingDateObject.toLocaleString('default', { month: 'short' }) + "-" + comingDateObject.getFullYear().toString().substr(-2) :'';
            let comingDateObjectE =(dateOfEvent)? new Date(dateOfEvent):'';
            let formattedDateE = (dateOfEvent)? comingDateObjectE.getDate() + "-" + comingDateObjectE.toLocaleString('default', { month: 'short' }) + "-" + comingDateObjectE.getFullYear().toString().substr(-2) :'';
            const dataBody = JSON.stringify({
                policyNumber: policyNumber,
                dobLa: formattedDateLA,
                doe: formattedDateE
            });
            $(el).find('.companion__details__value').text("");
            $.ajax({
                method:'POST',
                url:'/bin/chli/getClaimStatus',
                dataType:'json',
                data:dataBody,
                contentType:"application/json"
            }).done((res,status)=>{
                $(el).find('.companion__details__value').text(res.payload.claimStatus);
            }).fail((jqXhr,status)=>{
                $(el).find('.companion__details__value').text("Sorry, no record found!");
            });
        },
        handeButtonClick : (el)=>{
            $(el).find('.btn-proccedForDetail').on(CONSTANT.eventsListners.CLICK, function(e) {
                e.preventDefault();
                let policyNumber = $(el).find('.individualPolicy-tab').find('.policyNumber--input').val();
                let dobLifeInsured = $(el).find('.individualPolicy-tab').find('.dateOfBirthOfLifeInsured--input').val();
                let dateOfEvent = $(el).find('.individualPolicy-tab').find('.dateOfEvent--input').val();
                if (policyNumber && (dobLifeInsured || dateOfEvent)) {
                    $(el).find('.individualPolicy-tab').find('.claimStatusCheck__nav__item-error').addClass('invisible');
                    $(el).find('.individualPolicy-tab').find('.date_before').addClass('d-none');
                    checkClaimStatus.methods.handleAjax($(el).find('.individualPolicy-tab'),policyNumber , dobLifeInsured ,dateOfEvent);
                    checkClaimStatus.methods.buttonClickHandler($(el).find('.btn-proccedForDetail'));
                    $(el).find('.individualPolicy-tab').find('.claims__companion__details').css('display','block');
                } else {
                    $(el).find('.individualPolicy-tab').find('.claimStatusCheck__nav__item-error').removeClass('invisible');
                }
                checkClaimStatus.methods.handlePrevious($(el).find('.individualPolicy-tab').find('.claims__companion__details .claimStatusCheck__back'), false, el);
            });
            $(el).find('.claimStatusCheck--grp-proceed').on(CONSTANT.eventsListners.CLICK,(e)=>{
                e.preventDefault();
                let policyNumber = $(el).find('.groupPolicy-tab').find('.policyNumber--input').val();
                let dobLifeInsured = $(el).find('.groupPolicy-tab').find('.dateOfBirthOfLifeInsured--input').val();
                let dateOfEvent = $(el).find('.groupPolicy-tab').find('.dateOfEvent--input').val();
                if (policyNumber && (dobLifeInsured || dateOfEvent)) {
                    $(el).find('.groupPolicy-tab').find('.claimStatusCheck__nav__item-error').addClass('invisible');
                    $(el).find('.groupPolicy-tab .claimStatusCheck__form').addClass('d-none');
                    checkClaimStatus.methods.handleAjax($(el).find('.groupPolicy-tab'),policyNumber , dobLifeInsured ,dateOfEvent);
                    checkClaimStatus.methods.buttonClickHandler($(el).find('.claimStatusCheck--grp-proceed'));
                    $(el).find('.groupPolicy-tab').find('.claims__companion__details').css('display','block');
                } else {
                    $(el).find('.groupPolicy-tab').find('.claimStatusCheck__nav__item-error').removeClass('invisible');
                }
                checkClaimStatus.methods.handlePrevious($(el).find('.groupPolicy-tab').find('.claims__companion__details .claimStatusCheck__back'), true, el);
            });
        },
        handlePrevious : (button, isGroup, el)=>{
            $(button).on(CONSTANT.eventsListners.CLICK,()=>{
                if(isGroup){
                    $(el).find('.groupPolicy-tab .claimStatusCheck__form').removeClass('d-none');
                    $(el).find('.groupPolicy-tab').find('.claims__companion__details').css('display','none');
                }else{
                    $(el).find('.individualPolicy-tab').find('.claims__companion__details').css('display','none');
                    $(el).find('.individualPolicy-tab').find('.date_after').removeClass('d-none');
                }
            });
        },
        checkDateValue : (el)=>{
            $(el).find('.btn-proceed').on(CONSTANT.eventsListners.CLICK, function(e) {
                e.preventDefault();
                let claimDate = $(el).find('.claimDate--input').val();
                if(!claimDate){
                    $(el).find('.claimDate--input').next('.claimStatusCheck__nav__item-error').removeClass('invisible');
                }else{
                    $(el).find('.claimDate--input').next('.claimStatusCheck__nav__item-error').addClass('invisible');
                    let cutoffDate = new Date('2023-09-10');
                    if (new Date(claimDate) < cutoffDate) {
                        $(el).find('.date_after').addClass('d-none');
                        $(el).find('.date_before').removeClass('d-none');
                        checkClaimStatus.methods.buttonClickHandler($(el).find('.btn-proceed'));
                    } else {
                       $(el).find('.date_after').removeClass('d-none');
                       $(el).find('.date_before').addClass('d-none');
                       window.open($(this).attr('href'), '_blank');
                       checkClaimStatus.methods.buttonClickHandler($(el).find('.btn-proceed'));
                    }
                }
            });
            checkClaimStatus.methods.handeButtonClick(el);
        },

         buttonClickHandler: function (element) {
                 let buttonText = element.text().replace(/\s+/g, ' ').trim();
                 let title = null;
                 let container = element.closest('.claimStatusCheck');
                 let titleElement = container.find('.claimStatusCheck__div .claimStatusCheck__heading');
                 if (titleElement.length > 0) {
                    title = titleElement.text().trim();
                 }
                 var obj = checkClaimStatus.methods.dataLayerObj(buttonText, title);
                    createDataLayer('buttonClick', obj);
         },

         dataLayerObj: function (el,e) {
          var obj = {
               'articleName': "",
               'blogCategory': "",
               'blogPageCategory': "",
               'buttonText': el ? el : "",
               'pageSection': e ? e : "Check Claim Status Component",
               'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
               'planOption': "",
               'productCategory': "",
               'productName': "",
               'question': "",
               'source': "",
               'searchTerm': "",
               'videoTitle': "",
               'bannerName': "",
            };
            return obj;
          },

        init : ()=>{
            $('.claimStatusCheck').each((idx,ele)=>{
                checkClaimStatus.methods.checkDateValue(ele);
            });
        }
    }
};

$(()=>{
    checkClaimStatus.methods.init();
});

